module.exports = __webpack_public_path__ + "static/media/mt-guru.7bcbaa25.webp";